<template>
    <div class="container">
        <PatientsListingFilters :filters="params" :order-options="['oldest', 'newest']" @change="onFilters" />

        <div class="matrix-panel">
            <div class="table-layout table-patient table-clinician table-inactive">
                <TableHeader v-if="patients.length !== 0" :phase="phase" />

                <PatientsListingTableBody
                    ref="TableBody"
                    :phase="phase"
                    :params="params"
                    @fetched="onFetched"
                >
                    <PatientRow v-for="patient in patients" :key="patient.id" :phase="phase" :patient="patient" />
                </PatientsListingTableBody>
            </div>
        </div>
    </div>
</template>

<script>
import PatientRow from '@components/CoachAdmin/PatientsMatrix/Inactive/PatientRow'
import TableHeader from '@components/CoachAdmin/PatientsMatrix/Inactive/TableHeader'

import PatientsListing from '@components/PatientsMatrix/PatientsMatrix'

export default {
    components: {
        PatientRow,
        TableHeader
    },
    extends: PatientsListing,
    mounted() {
        $(function() {
            $(".item-patient-inactive").addClass("active");
        })
    }
}
</script>
